import {
  AfterVideoLoadedEvent,
  FormatContext,
  ILoadingStrategy
} from './loading-strategy';
import { RootStore } from '../../../../common/js/stores/root.store';

export class ShouldDisplayVastIconStrategy implements ILoadingStrategy {
  isRunnable(): boolean {
    return true;
  }

  alterConfiguration(formatContext: FormatContext): FormatContext {
    return formatContext;
  }

  afterVideoLoaded(event: AfterVideoLoadedEvent): AfterVideoLoadedEvent {
    const displayVastIcon = Boolean(
      event.ctx.config.displayVastIcon && event.result.vastClient.getVastIcon()
    );

    event = {
      ...event,
      ctx: {
        ...event.ctx,
        config: {
          ...event.ctx.config,
          displayVastIcon: displayVastIcon
        }
      }
    };
    RootStore.getInstance().configStore.alterConfiguration({
      displayVastIcon
    });
    return event;
  }
}
